import { lazy } from 'react'

export const YoEffectV1 = lazy(() => import('./v1/YoEffectV1'))
export const YoEffectV2 = lazy(() => import('./v2/YoEffectV2'))
